var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mainConfig.enableBidding)?_c('small',{staticClass:"ta-lot-no-of-bids"},[_vm._v(_vm._s(_vm.lot.num_of_bids || 0)+" "+_vm._s(_vm.$t('bids')))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }